import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { updateFromWebSocket, updateSingleCounter, clearError } from '../store/slices/countersSlice';

export const useCounters = () => {
  const dispatch = useDispatch();
  const counters = useSelector((state) => state.counters);

  // Обновить счетчики из WebSocket
  const updateCounters = useCallback((data) => {
    dispatch(updateFromWebSocket(data));
  }, [dispatch]);

  // Обновить один счетчик
  const updateCounter = useCallback((type, count) => {
    dispatch(updateSingleCounter({ type, count }));
  }, [dispatch]);

  // Очистить ошибки
  const clearErrors = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  // Получить счетчик для меню
  const getMenuCounter = useCallback((type) => {
    const count = counters[type] || 0;
    return count;
  }, [counters]);

  // Проверить, нужно ли показывать бейдж
  const shouldShowBadge = useCallback((type) => {
    const count = counters[type] || 0;
    const shouldShow = count > 0;
    return shouldShow;
  }, [counters]);

  return {
    // Данные
    counters,
    inventory: counters.inventory,
    tasks: counters.tasks,
    shop: counters.shop,
    network: counters.network,
    battlePass: counters.battlePass,
    
    // Детали
    details: counters.details,
    
    // Состояние
    isLoading: counters.isLoading,
    error: counters.error,
    lastUpdate: counters.lastUpdate,
    
    // Методы
    updateCounters,
    updateCounter,
    clearErrors,
    getMenuCounter,
    shouldShowBadge,
  };
};
